import { forwardRef } from "react";
import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const RolloverTaskTypeDropdown = forwardRef(
  ({ id, name, label, dataSource, fields, change, ...rest }, ref) => {
    const { i18n } = useTranslation();

    return (
      <DropDown
        ref={ref}
        id={id}
        name={name}
        label={label}
        dataSource={dataSource}
        fields={fields}
        locale={i18n?.language}
        change={change}
        sortOrder="Ascending"
        allowObjectBinding
        {...rest}
      />
    );
  }
);
